import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { TourTrackingContext } from 'ui-shepherd-react/contexts/TourTrackingContext';
import { TourUsageTracker } from '../usageTracker';
import { TourTrackingObserver } from '../TourTrackingObserver';
export const TourTrackingProvider = ({
  appName,
  children,
  enableAutoTracking = true
}) => {
  const usageTracker = new TourUsageTracker(appName);
  const tourTrackingObserver = enableAutoTracking ? new TourTrackingObserver(usageTracker) : undefined;
  const prevTourTrackingObserverRef = useRef(); // Prevent duplicate tracking observer on tour when provider is rerendered for any reason

  useEffect(() => {
    const {
      current: prevTrackingObserver
    } = prevTourTrackingObserverRef;
    prevTourTrackingObserverRef.current = tourTrackingObserver;

    if (prevTrackingObserver && prevTrackingObserver !== tourTrackingObserver) {
      prevTrackingObserver.stopObserve();
    }
  });
  return /*#__PURE__*/_jsx(TourTrackingContext.Provider, {
    value: {
      appName,
      usageTracker,
      tourTrackingObserver
    },
    children: children
  });
};